import { render, staticRenderFns } from "./RuleEdit.vue?vue&type=template&id=42bb3a06&scoped=true&"
import script from "./RuleEdit.vue?vue&type=script&lang=js&"
export * from "./RuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./RuleEdit.vue?vue&type=style&index=0&id=42bb3a06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb3a06",
  null
  
)

export default component.exports